import request from '@/util/request'
import {optionsToPaginationParams} from '@/util/pagination'

const state = {
  selected_alert: {
    id: null,
    subject: null,
    smsText: null,
    body: null,
    type: null,
    external: null,
    alertId: null,
    userId: null,
    read: null,
  },
  read_alerts: [],
  unread_alerts: [],
  alerts_admin: [],
  stock_alerts_admin: [],
}

const getters = {
  getUnreadAlerts: (state) => state.unread_alerts,
  getReadAlerts: (state) => state.read_alerts,
  getAlertsAdmin: (state) => state.alerts_admin,
  getStockAlertsAdmin: (state) => state.stock_alerts_admin,
}

const actions = {
  fetchAlertsAdmin({getters, commit}, {options, query}) {
    const paginationParams = optionsToPaginationParams(options)
    return request({
      url: '/alerts/',
      params: {query, ...paginationParams},
      method: 'get',
    }).then((data) => {
      commit('SET_ALERTS_ADMIN', data)
    })
  },
  fetchStockAlertsAdmin({getters, commit}, {options, query}) {
    const paginationParams = optionsToPaginationParams(options)
    return request({
      url: '/product-stock-alerts/admin',
      params: {query, ...paginationParams},
      method: 'get',
    }).then((data) => {
      commit('SET_STOCK_ALERTS_ADMIN', data)
    })
  },
  fetchReadAlertsUser({getters, commit}) {
    return request({
      url: `/alerts/recipient/${getters.getSelectedCompany.id}/1`,
      method: 'get',
    }).then((data) => {
      commit('SET_READ_ALERTS', data.data.rows)
    })
  },
  fetchUnreadAlertsUser({getters, commit}) {
    return request({
      url: `/alerts/recipient/${getters.getSelectedCompany.id}/0`,
      method: 'get',
    }).then((data) => {
      commit('SET_UNREAD_ALERTS', data.data.rows)
    })
  },
  sendAlert({getters, commit}, data) {
    return request({
      url: '/alerts',
      method: 'post',
      data,
    })
  },
  // eslint-disable-next-line no-empty-pattern
  deleteAlert({}, {alertId}) {
    return request({
      url: `/alerts/delete/${alertId}`,
      method: 'delete',
    })
  },
  // eslint-disable-next-line no-empty-pattern
  fetchAlertById({getters}, {alertId}) {
    return request({
      url: `/alerts/recipient/${getters.getSelectedCompany.id}/alert/${alertId}`,
      method: 'get',
    }).then((result) => {
      return result
    })
  },
  markAlertAsRead({getters, commit}, {alertId, read = 1}) {
    return request({
      url: `/alerts/read/${alertId}/${read}`,
      method: 'post',
    })
  },
}

const mutations = {
  SET_READ_ALERTS(state, alerts) {
    state.read_alerts = alerts
  },
  SET_UNREAD_ALERTS(state, alerts) {
    state.unread_alerts = alerts
  },
  SET_ALERTS_ADMIN(state, alerts_admin) {
    state.alerts_admin = alerts_admin
  },
  SET_STOCK_ALERTS_ADMIN(state, stock_alerts_admin) {
    state.stock_alerts_admin = stock_alerts_admin
  },
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
}
